import EventIcon from "@mui/icons-material/Event";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleIcon from "@mui/icons-material/People";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const cards = [
  { key: "appointments", label: "Scheduled", icon: EventIcon, bg: "bg-amber-100 dark:bg-amber-900/40", text: "text-amber-700 dark:text-amber-300", iconBg: "bg-amber-500" },
  { key: "pending", label: "Upcoming", icon: ScheduleIcon, bg: "bg-orange-100 dark:bg-orange-900/40", text: "text-orange-700 dark:text-orange-300", iconBg: "bg-orange-500" },
  { key: "inqueue", label: "In Queue", icon: PeopleIcon, bg: "bg-sky-100 dark:bg-sky-900/40", text: "text-sky-700 dark:text-sky-300", iconBg: "bg-sky-500" },
  { key: "ongoing", label: "Ongoing", icon: PlayCircleIcon, bg: "bg-lime-100 dark:bg-lime-900/40", text: "text-lime-700 dark:text-lime-300", iconBg: "bg-lime-500" },
  { key: "completed", label: "Completed", icon: CheckCircleIcon, bg: "bg-emerald-100 dark:bg-emerald-900/40", text: "text-emerald-700 dark:text-emerald-300", iconBg: "bg-emerald-500" },
  { key: "cancelled", label: "Cancelled", icon: CancelIcon, bg: "bg-red-100 dark:bg-red-900/40", text: "text-red-700 dark:text-red-300", iconBg: "bg-red-500" },
  { key: "reschudle", label: "Rescheduled", icon: EventRepeatIcon, bg: "bg-cyan-100 dark:bg-cyan-900/40", text: "text-cyan-700 dark:text-cyan-300", iconBg: "bg-cyan-500" },
  { key: "noshow", label: "No Show", icon: VisibilityOffIcon, bg: "bg-slate-100 dark:bg-slate-700", text: "text-slate-700 dark:text-slate-200", iconBg: "bg-slate-500" },
];

function AppointmentCounts({ count }: any) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2 sm:gap-3 p-2">
      {cards.map(({ key, label, icon: Icon, bg, text, iconBg }) => (
        <div key={key} className={`${bg} rounded-lg sm:rounded-xl p-1 sm:p-2 flex flex-row sm:flex-col items-center justify-center transition-colors`}>
          <div className="hidden sm:flex w-8 h-8 items-center justify-center sm:mb-2">
            <div className={`w-8 h-8 ${iconBg} rounded-lg flex items-center justify-center`}>
              <Icon className="text-white" sx={{ fontSize: 20 }} />
            </div>
          </div>
          <div className="flex flex-row sm:flex-col items-center justify-center gap-1.5 sm:gap-0">
            <h3 className={`text-sm sm:text-xl font-bold ${text} leading-tight`}>{count?.[key] ?? 0}</h3>
            <span className={`text-[6px] sm:text-[8px] font-medium ${text} uppercase tracking-wide text-center leading-tight`}>{label}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AppointmentCounts;

